import { DEFAULT_ENVIRONMENT } from "../../constants";

export interface EnvironmentConfig {
  apiUrl: string;
  model?: string;
  sumUpModel?: string;
  apiBase: string;
  baseUrl: string;
}

const ENV_CONFIGS: Record<string, EnvironmentConfig> = {
  local: {
    apiUrl: "http://localhost:8080/api/v1/oa/outlook/completions",
    model: "3d2d4fe6-d454-48af-be38-9ec180e5b19c",
    sumUpModel: "6ce1f40f-f810-4347-8d25-f3bec25b16a1",
    apiBase: "http://localhost:8080/api/v1/chats",
    baseUrl: "https://localhost:3000",
  },
  dev: {
    apiUrl: "https://dev.api.karli.ai/api/v1/oa/outlook/completions",
    model: "3d2d4fe6-d454-48af-be38-9ec180e5b19c",
    apiBase: "https://dev.api.karli.ai/api/v1/chats",
    baseUrl: "https://dev.karli-email-response.karli.ai",
  },
  devgeneral: {
    apiUrl: "https://dev.api.karli.ai/api/v1/oa/outlook/completions",
    sumUpModel: "6ce1f40f-f810-4347-8d25-f3bec25b16a1",
    apiBase: "https://dev.api.karli.ai/api/v1/chats",
    baseUrl: "https://dev.karli-email-response.karli.ai",
  },
  general: {
    apiUrl: "https://api.karli.ai/api/v1/oa/outlook/completions",
    apiBase: "https://api.karli.ai/api/v1/chats",
    baseUrl: "https://karli-email-response.karli.ai",
  },
  "9e4864ad-ab0f-4830-abbf-b0a85c365974": {
    apiUrl: "https://api.karli.ai/api/v1/oa/outlook/completions",
    model: "f67cfe78-7365-4221-b0fe-5ac1b93342ec",
    apiBase: "https://api.karli.ai/api/v1/chats",
    baseUrl: "https://karli-email-response.karli.ai",
  },
};

export function getQueryParam(name: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

export function getEnvironmentConfig(): EnvironmentConfig {
  const envId = getQueryParam("env") || DEFAULT_ENVIRONMENT;
  const config = ENV_CONFIGS[envId];

  if (!config) {
    console.warn(`Unknown environment "${envId}", falling back to default`);
    return ENV_CONFIGS[DEFAULT_ENVIRONMENT];
  }

  return config;
}

export function getBaseApiUrl(): string {
  const config = getEnvironmentConfig();
  const url = new URL(config.apiUrl);
  return url.origin;
}

export function getBaseUrl(): string {
  const config = getEnvironmentConfig();
  return config.baseUrl;
}

export function getApiBase(): string {
  const config = getEnvironmentConfig();
  return config.apiBase;
}

export function getAgentId(): string {
  return getEnvironmentConfig().model;
}
